import useDefinedContext from "hooks/useDefinedContext";
import SetSelectedEntitiesContext from "../SetSelectedEntitiesContext";

function useSetGroupsFilter<T = never, K = T extends any ? React.Dispatch<React.SetStateAction<T[]>> : never>() {
  return useDefinedContext(SetSelectedEntitiesContext) as K;
}

export default useSetGroupsFilter;
